<section class="FirstScroll_Section">
    <div class="container nopad">
        <div class="row parentContainer">

          <div class="col-12 videosContainer" *ngFor="let video of videoGallery">
              <div *ngIf="video.videos?.file" class="col-4 normalVideo">
                <a (click)="viewVideoGallery(video)" class="video">
                    <video src="{{baseUrl}}/{{video.videos?.file}}" width="350" height="196">
                      </video>
                    <a class="pin pin1"><span class="fa fa-play"></span></a>
                </a>
                <p class="card-text">{{video.title}}</p> 
              </div>

                <div class="col-4 youtubeVideo video" *ngIf="video.videos?.url">
                  <youtube-player videoId="{{video.videos?.video_id}}" HideProgressBar="2" Hide="0" [height]="203"
                  [width]="350"></youtube-player>

                <p class="card-text">{{video.title}}</p> 
                </div>

<!-- Modal -->
<!-- <div class="modal fade" id="myModal1" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">      
        <div class="modal-body">
         <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>        
          <div class="embed-responsive embed-responsive-16by9">
              <video class="embed-responsive-item" controls autoplay>
                <source src="{{baseUrl}}/{{video.videos?.file}}">
              </video> 
          </div> 
        </div>
      </div>
    </div>
  </div>    --> 
          </div>         
        </div>
    </div>
</section> 